import { Component, OnInit } from '@angular/core';
import { ServerService } from '../services/server.service';
import { Router } from '@angular/router';
import * as Feather from 'feather-icons';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
declare var iziToast: any;
declare var $: any;

@Component({
  selector: 'app-buy-credits',
  templateUrl: './buy-credits.component.html',
  styleUrls: ['./buy-credits.component.css']
})
export class BuyCreditsComponent implements OnInit {
  
  callbalances: any = {};
  minThrehold: any;
  showInput = false;
  addcredits: FormGroup;

  constructor(private router: Router, public serverService: ServerService) { }

  ngOnInit(): void {
    this.callbalance();
    this.addcredits = new FormGroup({
      'customername': new FormControl(localStorage.getItem('cn'),
        Validators.required),
      'topupvalue': new FormControl(null, Validators.required),
    });
  }

  addCreditsModal() {
    $('#addcredits').modal('show');
  }


  paymentCredits() {
    if (this.addcredits.valid) {
      let customer_id: any = localStorage.getItem('en');
      let data: any = new Object();
      let datas: any = new Object();
      data.action = "topup_add";
      data.topup_name = "Call Topup Amount";
      data.qty = "1";
      data.customer_id = customer_id;
      data.topup_amount = this.addcredits.value.topupvalue;
      datas.operation = "curlDatas";
      datas.moduleType = "login";
      datas.api_type = "web";
      datas.element_data = data;
      this.serverService.sendServer(datas).subscribe((res: any) => {
        if (res.status == "true") {
          $('#addcredits').modal('hide');
          this.router.navigate(['credit-payments'], { state: { page: this.addcredits.value.topupvalue } });
        }
      })

    }
  }




  callbalance() {

    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    datas.action = "call_balance";
    datas.customer_id = customer_id;

    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      // console.log(response)
      if (response.status == "true") {
        this.callbalances = response.call_balance_list

      }
      else {
        this.callbalances = {}
      }
      // console.log(this.callbalances)
    },
      (error) => {
        // console.log(error);
      });
  }

        

  editMinimum() {
    this.showInput = !this.showInput;
    this.minThrehold = this.callbalances.threshold_limit1;
  }

  cancelSubmitThrehold(){
    this.showInput = !this.showInput;
  }

  submitThrehold() {

    let sendThrehold: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');

    sendThrehold.action = "call_cost_minimum_balance_update";
    sendThrehold.customer_id = customer_id;
    sendThrehold.minimum_balance_amt = this.minThrehold;

    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = sendThrehold;
    this.serverService.sendServer(datasend).subscribe((response: any) => {

      if (response.status == "true") {
        iziToast.success({
          message: "Updated the Minimum Value Successfully!",
          position: 'topRight'
      });

        this.showInput = !this.showInput;
        this.callbalances.threshold_limit1 = this.minThrehold;
      }
      else {
        iziToast.error({
          message: "Some Error occur Please Try Again Later",
          position: 'topRight'
      });

      }

    },
      (error) => {

      });

  }



}
